import toastr from 'toastr';

import { constants as config } from '@config';

const PopupMenuCommonFunctions = require('./popupmenu-common-functions');

const LibraryFactory = require('../../../factory/library').factory;
const LibraryPopulatorFactory = require('../../../factory/library/library-populator');
const { isDataURL } = require('../../../../helpers/dataUrl');

const { loadTableEvents } = require('./popupmenu-table-events');
const { loadTextEvents } = require('./popupmenu-text-events');

module.exports = Backbone.View.extend({
  initialize: function () {
    this.popupMenuCommonFunctions = new PopupMenuCommonFunctions();
  },

  loadEvents: function (target) {
    const popupMenuCommonFunctions = this.popupMenuCommonFunctions;
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const popup = $(target).popupmenu()[0];

    function handleAlignment (target, position) {
      const $container = $(target).parents('.ui-dropdown-items');
      const offset = $container.find('input#margin').val() * 0.01;
      const selectedElements = canvas.getSelectedElems();
      const relativeTo = selectedElements && selectedElements?.length > 1 ? 'selection' : 'page';

      INKIVE.EditorFacade.handle('align', {
        relative_to: relativeTo,
        position,
        offset
      });
    }

    function confirmStickerExplode (elem, explode) {
      const message = INKIVE.TranslateHelper.translate($(elem).find('.textarea.subelement')
        ? 'modal.alert.explode_banner'
        : 'modal.alert.explode_placeholder');

      INKIVE.Modal.alertMessage(message, {
        width: 450,
        callback: [explode, $.noop]
      });
    }

    function addRotation (angle) {
      const selectedElements = canvas.getSelectedElems();
      canvas.runExtensions('clear', {});
      selectedElements.forEach(elem => {
        const newAngle = canvas.getRotationAngle(elem) * 1 + angle;
        canvas.selectOnly([elem], false);
        INKIVE.DesignFacade.set({ rotation: newAngle });
      });
      canvas.selectOnly(selectedElements, false);
    }

    function toggle (attributeName, value) {
      if (value !== true && value !== false) {
        const id = popup.element().getAttribute('id');
        value = !INKIVE.DesignFacade.get(id)[attributeName];
      }

      const data = {};
      data[attributeName] = value;

      INKIVE.DesignFacade.set(data);
      INKIVE.Menus.elementPopupMenu.refresh();
    }

    popup.button('on_imageFilter').on('click', function () {
      $(this).filterpicker({ $svgImageElement: $(target) });
    });

    popup.button('on_align-vertical-middle').on('click', function (event) {
      handleAlignment(event.target, 'vertical_middle');
    });

    popup.button('on_align-horizontal-middle').on('click', function (event) {
      handleAlignment(event.target, 'horizontal_middle');
    });

    popup.button('on_align-left').on('click', function (event) {
      handleAlignment(event.target, 'left');
    });

    popup.button('on_align-right').on('click', function (event) {
      handleAlignment(event.target, 'right');
    });

    popup.button('on_align-top').on('click', function (event) {
      handleAlignment(event.target, 'top');
    });

    popup.button('on_align-bottom').on('click', function (event) {
      handleAlignment(event.target, 'bottom');
    });

    popup.button('on_explode_sticker').on('click', function () {
      const elem = popup.element();
      const hasSubelement = $(elem).find('.textarea.subelement, .layoutBox.subelement').length > 0;
      const explode = _.partial(INKIVE.DesignFacade.handle, elem.getAttribute('id'), 'explode');

      hasSubelement && confirmStickerExplode(elem, explode);
      hasSubelement || explode();
    });

    popup.button('on_opacity')
      .on('start', $.noop)
      .on('change', function (e, val) {
        if (typeof val === 'undefined') return;
        canvas.changeSelectedAttributeNoUndo('opacity', parseFloat(val) / 100, canvas.getSelectedElems());
      })
      .on('stop', function (e, val) {
        INKIVE.DesignFacade.set({ opacity: parseFloat(val) / 100 });
        $(popup.element()[0]).is('image') && canvas.runExtensions('showBackgroundPopupMenu');
      });

    popup.button('on_stroke')
      .on('start', $.noop)
      .on('change', function (e, val) {
        if (typeof val !== 'number') return;
        $(this).find('svg line').attr('stroke-width', val);
        $(this).find('.stroke-dasharray').toggle(val > 0);
        const strokeValue = parseFloat(val);
        const selectedItems = canvas.getSelectedElems();
        for (let i = 0; i < selectedItems.length; i++) {
          const elem = selectedItems[i];
          if (elem.classList.contains('textarea')) {
            const textarea = new INKIVE.Text.Textarea().setDOM(elem);
            textarea.text.stroke_width = strokeValue;
            canvas.runExtensions('renderTextArea', { textArea: textarea });
          } else {
            canvas.setStrokeWidth(strokeValue, popupMenuCommonFunctions.getElemsForStrokeChange(elem));
          }
        }
      })
      .on('stop', function (e, val) {
        const selectedItems = canvas.getSelectedElems();
        for (let i = 0; i < selectedItems.length; i++) {
          const elem = selectedItems[i];
          const elementData = INKIVE.DesignFacade.get(elem.getAttribute('id'));
          const shapes = {};

          switch (elementData.type) {
            case 'text':
              INKIVE.DesignFacade.set({ stroke: { width: val } });
              break;
            case 'shape':
              INKIVE.DesignFacade.set({ stroke: { width: val } });
              break;
            case 'sticker':
              for (let i = 0; i < elementData.shapes.length; i++) {
                shapes[i] = { stroke: { width: val } };
              }

              INKIVE.DesignFacade.set({ shapes });
          }
        }
      });

    popup.button('on_sendForward').on('click', function () {
      INKIVE.DesignFacade.handle(popup.element().getAttribute('id'), 'send_forward');
    });

    popup.button('on_sendBackward').on('click', function () {
      INKIVE.DesignFacade.handle(popup.element().getAttribute('id'), 'send_backward');
    });

    popup.button('on_sendTop').on('click', function () {
      INKIVE.DesignFacade.handle(popup.element().getAttribute('id'), 'send_top');
    });

    popup.button('on_sendBottom').on('click', function () {
      INKIVE.DesignFacade.handle(popup.element().getAttribute('id'), 'send_bottom');
    });

    popup.button('on_rotateLeft').on('click', _.partial(addRotation, -10));
    popup.button('on_rotateRight').on('click', _.partial(addRotation, 10));

    popup.button('on_setBackground').on('click', function () {
      INKIVE.EditorFacade.handle(popup.element().getAttribute('id'), 'set_as_background');
      popup.destroy();
    });

    popup.button('on_backgroundReposition').on('click', function () {
      INKIVE.EditorFacade.handle('background', 'crop');
    });

    popup.button('on_backgroundFilter').on('click', function () {
      $(this).filterpicker({ $svgImageElement: $(target) });
    });

    popup.button('on_removeElement').on('click', function () {
      const ids = canvas.getSelectedElems().map((elem) => {
        return elem.getAttribute('id');
      });

      if (ids.length > 5) {
        INKIVE.DesignFacade.handle('delete_multiple');
      } else {
        _.each(ids, function (id) {
          INKIVE.DesignFacade.handle(id, 'delete');
        });
      }

      popup.destroy();
    });

    popup.button('on_copyElement').on('click', function () {
      INKIVE.DesignFacade.handle(popup.element().getAttribute('id'), 'duplicate');
      INKIVE.Tool.blinkScreen(popup.element());
    });

    popup.button('on_reposition').on('click', function () {
      const $image = $(popup.element()).is('.sticker')
        ? $(popup.element()).find('image')
        : $(popup.element());
      INKIVE.EditorFacade.handle($image.attr('id'), 'crop');
    });

    popup.button('on_crop').on('click', function () {
      const id = popup.element().getAttribute('id');
      INKIVE.EditorFacade.handle(id, 'crop', { scale: 1 });
    });

    popup.button('on_lockElement').on('click', function () {
      INKIVE.DesignFacade.set({ locked_image: true });
    });

    popup.button('on_unlockElement').on('click', function () {
      INKIVE.DesignFacade.set({ locked_image: false });
    });

    popup.button('on_flipImageH').on('click', function () {
      if ($('#' + canvas.getSelectedElems()[0].id + '-loader').length) {
        canvas.call('advice.show', 'image-flip-disabled');
        return;
      }

      INKIVE.DesignFacade.set({ flipped: { horizontal: true } });
    });

    popup.button('on_flipImageV').on('click', function () {
      if ($('#' + canvas.getSelectedElems()[0].id + '-loader').length) {
        canvas.call('advice.show', 'image-flip-disabled');
        return;
      }
      INKIVE.DesignFacade.set({ flipped: { vertical: true } });
    });

    popup.button('on_flipBackgroundH').on('click', function () {
      if ($('#' + canvas.getSelectedElems()[0].id + '-loader').length) {
        canvas.call('advice.show', 'image-flip-disabled');
        return;
      }
      INKIVE.DesignFacade.set({ flipped: { horizontal: true } });
    });

    popup.button('on_flipBackgroundV').on('click', function () {
      if ($('#' + canvas.getSelectedElems()[0].id + '-loader').length) {
        canvas.call('advice.show', 'image-flip-disabled');
        return;
      }
      INKIVE.DesignFacade.set({ flipped: { vertical: true } });
    });

    popup.button('on_imageBox').on('click', function () {
      INKIVE.EditorFacade.handle('convert_to_image_box');
    });

    popup.button('on_set_permissions').on('click', function () {
      $('.tool-menu li > a[href="#tabRestrictions"]').trigger('click');

      if (INKIVE.Menus?.showSimplifiedRestrictions && $('.simplified-restrictions').is('.hidden')) {
        canvas.call('advice.show', 'choose-restriction-option');
      }
    });

    popup.button('on_layoutConfirm').on('click', function () {
      $(popup.element()).trigger('dblclick');
    });

    popup.button('on_layoutClose').on('click', function () {
      const clipper = $('.clipperImage .layoutClipperImage')[0];
      canvas.runExtensions('cropLayoutContent', {
        layout: clipper,
        elem: clipper,
        hasChanges: false
      });
    });

    popup.button('on_bgRemoval').on('click', function () {
      this.classList.add('disabled');
      INKIVE.DesignFacade.handle('remove_background');
    });

    // -- For Image Elements ---------------------------------------------------------------------------------------
    popup.button('on_set-left').on('click', function () {
      canvas.moveSelectedElements(-10, 0);
    });

    popup.button('on_set-right').on('click', function () {
      canvas.moveSelectedElements(10, 0);
    });

    popup.button('on_set-up').on('click', function () {
      canvas.moveSelectedElements(0, -10);
    });

    popup.button('on_set-down').on('click', function () {
      canvas.moveSelectedElements(0, 10);
    });

    popup.button('on_flipH').on('click', function () {
      INKIVE.DesignFacade.handle('flip_horizontal');
    });

    popup.button('on_flipV').on('click', function () {
      INKIVE.DesignFacade.handle('flip_vertical');
    });

    popup.button('on_groupGroup').on('click', function () {
      INKIVE.C.BOOK_TYPE.TEMPLATE === INKIVE.C.BOOK.book_type && canvas.call('advice.show', 'group-template');

      INKIVE.DesignFacade.create('group');
    });

    popup.button('on_groupUngroup').on('click', function () {
      INKIVE.DesignFacade.handle('ungroup');
      canvas.clearSelection();
    });

    popup.button('on_lockElement').on('click', _.partial(toggle, 'locked', true));
    popup.button('on_unlockElement').on('click', _.partial(toggle, 'locked', false));

    popup.button('on_increaseElement').on('click', function () {
      (new INKIVE.Gesture(canvas)).testResize(popup.element());
    });

    popup.button('on_decreaseElement').on('click', function () {
      (new INKIVE.Gesture(canvas)).testResize(popup.element(), true);
    });

    popup.button('on_imageTab').on('click', function () {
      canvas.clearSelection();
      $('[data-toggle="tab"][href="#tabImages"]').tab('show');
    });

    popup.button('on_set-source').on('click', function () {
      const PromptModal = require('../../../modal/prompt');

      const prompt = new PromptModal({
        label: INKIVE.TranslateHelper.translate('modal.prompt.add_video')
      });

      const modal = INKIVE.Modal.modalWindow(prompt.getFormHtml(), {
        width: 400,
        headerIcon: 'fa fa-film',
        headerTitle: 'tool.customize.add_video',
        buttons: [{
          title: INKIVE.TranslateHelper.translate('modal.buttons.add_video'),
          onClick: function () {
            modal.close();

            const source = prompt.getValue();
            source && INKIVE.DesignFacade.set({ source });
          }
        }]
      });
    });

    popup.button('on_toggle-autoplay').on('click', _.partial(toggle, 'autoplay'));
    popup.button('on_toggle-move-to-next').on('click', _.partial(toggle, 'movetonext'));
    popup.button('on_toggle-controls').on('click', _.partial(toggle, 'controls'));
    popup.button('on_toggle-fullscreen').on('click', _.partial(toggle, 'fullscreen'));
    popup.button('on_toggle-loop').on('click', _.partial(toggle, 'loop'));
    popup.button('on_toggle-mute').on('click', _.partial(toggle, 'mute'));

    popup.button('on_restrictionInfo').on('click', function () {
      const elementId = canvas.getSelectedElems()[0].id;
      const message = INKIVE.RestrictionsFacade.shownRestrictionMessages[elementId];
      message && toastr.info(message);
    });

    popup.button('on_library_add_quiet').on('click', function () {
      const elem = popup.element();
      if (elem.hasAttribute('xlink:href')) {
        const xlink = elem.getAttribute('xlink:href');
        if (isDataURL(xlink)) {
          canvas.call('advice.show', 'save-first');
          return;
        }
      }

      const libraryInstance = new LibraryFactory({
        librarySource: 'member'
      });

      LibraryPopulatorFactory.setLibrary(libraryInstance);
      LibraryPopulatorFactory.addElementToLibrary(elem, null, true);
    });

    popup.button('on_unlink_smart_asset').on('click', function () {
      const element = popup.element();
      element.removeAttribute(config.smartAssets.attributes.definedAsset);
      element.removeAttribute(config.smartAssets.attributes.definedContentType);

      canvas.clearSelection();
    });

    popup.button('on_deselect').on('click', function () {
      canvas.clearSelection();
      canvas.runExtensions('selectedChanged');
    });

    popup.button('on_bleedsize').on('change', function (e, val) {
      if (val) {
        val = parseFloat(val);

        _.isNumber(val) && canvas.runExtensions('modifyBleedValues', { size: val });

        $(this).find('input').val(val);
      }
    });

    popup.button('on_bleedClose').on('click', function () {
      canvas.runExtensions('hideManageBleed', {});
    });

    popup.button('on_HeaderAndFooterClose').on('click', function () {
      canvas.runExtensions('hideHeaderAndFooter', {});
    });

    popup.button('on_HeaderAndFooterPageSettings').on('click', function () {
      INKIVE.EditorFacade.trigger('popupmenu.headerFooter.open');
    });

    // Text
    loadTextEvents(popup, popupMenuCommonFunctions, canvas);

    // Table
    loadTableEvents(popup, popupMenuCommonFunctions, canvas);

    popup.button('on_restrict_changes').on('click', function () {
      document.querySelector('.tool-menu li > a[href="#tabSimplifiedRestrictions"]').click();
    });

    popup.button('on_animate').on('click', () => {
      document.querySelector('.tool-menu li > a[href="#tabAnimation"]')?.click();
    });

    // Distribution
    popup.button('on_distribute-horizontal').on('click', function () {
      INKIVE.EditorFacade.handle('distribute', 'horizontal', {
        selectedElements: canvas.getSelectedElems()
      });
    });

    popup.button('on_distribute-vertical').on('click', function () {
      INKIVE.EditorFacade.handle('distribute', 'vertical', {
        selectedElements: canvas.getSelectedElems()
      });
    });

    // tidy

    popup.button('on_tidy').on('click', function () {
      INKIVE.EditorFacade.handle('distribute', 'tidy', {
        selectedElements: canvas.getSelectedElems()
      });
    });

    INKIVE.DesignFacade.on('background.remove_background.skip', popupMenuCommonFunctions.toggleBackgroundRemovalIcon);
    INKIVE.DesignFacade.on('background.remove_background.error', popupMenuCommonFunctions.toggleBackgroundRemovalIcon);
    INKIVE.DesignFacade.on('image.remove_background.skip', popupMenuCommonFunctions.toggleBackgroundRemovalIcon);
    INKIVE.DesignFacade.on('image.remove_background.error', popupMenuCommonFunctions.toggleBackgroundRemovalIcon);
  }
});
